var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMinus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-minus",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 2.769,
    viewBox: "0 0 18 2.769",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "minus-solid",
    d: "M32.615,226.769H17.385a1.385,1.385,0,1,1,0-2.769H32.615a1.385,1.385,0,1,1,0,2.769Z",
    transform: "translate(-16 -224)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMinus);
export default __webpack_public_path__ + "static/media/ic-minus.1729f5d16b6a9d9f02784358f8978a07.svg";
export { ForwardRef as ReactComponent };